import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "detail_providers",
        object: "detail_provider",
        header: [
            { text: "Nombre", value: "name" },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
